import { styled, SxProps } from '@mui/material'
import { getCompressedImageLink } from '$helper/functions/image-compression'
import { AvatarImage, AvatarImageProps } from './components/avatar-image'
import { AvatarSize } from './types'
import { AVATAR_SIZES } from './conf'
import './styles.scss'

export interface AvatarBaseProps extends AvatarImageProps {
  backgroundColor?: string
  sx?: SxProps
  hasBorder?: boolean
  hasDeleted?: boolean
  squareMode?: boolean
  disableCompression?: boolean
}

const DELETED_ACCOUNT_BACKGROUND =
  'linear-gradient(180deg, #B3B3B3 0%, #8C8C8C 100%)'

export function AvatarBase({
  src,
  size = AvatarSize.SM,
  backgroundColor,
  hasBorder,
  onClick,
  hasDeleted = false,
  sx,
  disableCompression,
  ...rest
}: AvatarBaseProps) {
  const showBorder = hasBorder === undefined ? !!src : hasBorder
  const background = hasDeleted ? DELETED_ACCOUNT_BACKGROUND : backgroundColor
  const compressionWidth =
    AVATAR_SIZES[size] < AVATAR_SIZES[AvatarSize._2XL] ? 120 : 200

  const compressedSrc = !disableCompression
    ? getCompressedImageLink(src, `width=${compressionWidth}&cache-first=true`)
    : `${src}?cache-first=true`

  return (
    <StyledAvatarImage
      src={hasDeleted ? '' : compressedSrc}
      size={size}
      onClick={onClick}
      sx={{
        background,
        backgroundColor: background ? undefined : 'veryLightGray',
        color: 'neutral000',
        fontSize: size
          ? `${Math.max(10, Math.round((AVATAR_SIZES[size] / 56) * 16))}px`
          : '10px',
        '&::after': {
          border:
            !hasDeleted && showBorder ? '1px solid rgba(0, 0, 0, 0.05)' : '',
        },
        ...sx,
      }}
      {...rest}
    />
  )
}

interface StyledAvatarImageProps {
  squareMode?: boolean
}

const StyledAvatarImage = styled(AvatarImage)<StyledAvatarImageProps>`
  font-weight: 700;
  border-radius: ${({ squareMode, size }) =>
    squareMode
      ? size && AVATAR_SIZES[size] < AVATAR_SIZES[AvatarSize.XS]
        ? '6px !important'
        : '12px !important'
      : ''};
  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: ${({ squareMode }) => (squareMode ? '15px' : '50%')};
  }
`
